import { backend_url } from "@/constants";
import { AXIOS_CONFIG } from "@/utils/api";
import axios from "axios";

export type VerifyEmailResult = {
  success: boolean;
  message: string;
  requirePassword?: boolean;
};

export const verifyEmail = async (
  code: string,
  email: string
): Promise<VerifyEmailResult> => {
  try {
    const response = await axios.post(
      `${backend_url}/api/auth/verify-code/`,
      { code, email },
      {
        ...AXIOS_CONFIG,
      }
    );

    return {
      success: response.status === 200,
      message: response.data.message || "Email verified successfully!",
      requirePassword: response.data?.content?.requirePassword === true,
    };
  } catch (error) {
    console.error("Error verifying email:", error);
    throw error;
  }
};

/**
 * Resends the verification code to the user's email.
 *
 * @param email - The user's email address
 * @param businessSlug - Optional business slug for multi-account resolution
 * @returns Promise that resolves to the resend result
 * @throws Will throw an error if the request fails
 */
export const resendVerificationCode = async (
  email: string,
  businessSlug?: string
): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await axios.post(
      `${backend_url}/api/auth/resend-verify/`,
      { email, ...(businessSlug && { businessSlug }) },
      {
        ...AXIOS_CONFIG,
      }
    );

    return {
      success: response.status === 200,
      message: response.data.message || "Verification code sent successfully",
    };
  } catch (error) {
    console.error("Error resending verification code:", error);
    throw error;
  }
};
